import Knight from "./Knight";

export const alphabet = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
];

export function Tile({
  row,
  column,
  boardSize,
  isWhite,
  isActive,
  isTraversed,
  isPossible,
  onClick,
  corner
}: {
  row: number;
  column: number;
  boardSize: number;
  isWhite: boolean;
  isActive: boolean;
  isTraversed: boolean;
  isPossible: boolean;
  onClick: any;
  corner?: string;
}) {
  return (
    <div
      className={
        "tile " +
        (isWhite ? "" : "black ") +
        (isActive || isTraversed ? "traversed " : "") +
        (isPossible ? "possible " : "") +
        ((corner !== "none") ? corner+"-corner" : "")
      }
      id={"tile-" + row + "-" + alphabet[column - 1]}
      data-row={row}
      data-col={column}
      style={{ width: 100 / boardSize + "%", height: 100 / boardSize + "%" }}
      onClick={onClick}
    >
      {isActive ? <Knight /> : ""}
      {row}
      {alphabet[column - 1]}
    </div>
  );
}